module.exports = __webpack_public_path__ + "img/firstBanner.c69d427d.jpg";